<script setup>
import PortalShell from '@/Layouts/PortalShell.vue'
</script>

<template>
  <PortalShell portal="supplier">
    <slot />
  </PortalShell>
</template>
